import React, { useState, useEffect, useRef, useLayoutEffect, useCallback } from "react";

// import "../";
import {
ApolloClient,
InMemoryCache,
ApolloProvider,
useQuery,
ApolloLink,
gql,
useLazyQuery } from
"@apollo/client";
import { RestLink } from "apollo-link-rest";
import { connect } from "react-redux";
import { Drawer, Radio, Space, Switch } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, CloseCircleFilled } from "@ant-design/icons";

import {
fetchKeywordsInit,
skillListingCount,
skillListingTotalCount,
toggleSearchFalse,
resetOpenSearchDropdown,
  searchSkillListingQueryInit,
  nlSearchExternalInit,
  nlSearchExternalClear,
} from
"../../redux/actions";
import { parseQueryResultState } from "../QueryPage/queryStateUrl";
import { buildExternalFiltersPayload } from "../QueryPage/filterPayloadMappers";

import {
fetchGigs,
SearchResponse,
SearchResponseRequested,
SearchValue,
SearchType,
SearchIconClicked,
fetchSearchSuggestions,
SearchSuggestions,
fetchRecentSearches,
fetchTrendingJobs,
clearRecentSearchInit,
ClearSearchSuggestions } from
"../../redux/actions";
import { HttpLink } from "apollo-link-http";
// import debounce from "lodash/debounce";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import history from "../../config/history";
import { set } from "lodash";
import { debounce, timeout, isHC } from "../../shared/helpers";
import { useLocation } from "react-router";
import { Button, Input, AutoComplete, Menu, Dropdown } from "antd";

import { DownOutlined } from "@ant-design/icons";
import {
StarOutlined,
StarFilled,
StarTwoTone,
UserOutlined } from
"@ant-design/icons";
// import closeIcon from "../../assets/icons/clarity_window-closeLine.svg";
// import carbonCloseFilled from "../../assets/icons/carbonCloseFilled.svg";
import ServiceOutkine from "../../assets/icons/service-outlined.svg";
import Suitcase from "../../assets/icons/suitcase.svg";
import closeIcon from "../../assets/icons/clarity_window-closeLine.svg";
import RecentlyViewed from "../../assets/icons/RecentlyViewed.svg";
import ArrowTrending from "../../assets/icons/ArrowTrending.svg";
import carbonCloseFilled from "../../assets/icons/carbonCloseFilled.svg";
import evaArrowBackOutline from "../../assets/icons/evaArrowBackOutline.svg";
import history from "../../routes/history";
import "./SearchBar.css";
const { Search } = Input;
// const url = useLocation();

const SearchBar = (props) => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const myAppUrl = process.env.REACT_APP_MY_URL;

  const url = useLocation();
  const dispatch = useDispatch();
  const { loggedInSearchBar, setloggedInSearchBar } = props;
  const [search, setSearch] = useState(() => {
    if (props.value) return props.value;
    const pathname = window.location.pathname;
    if (pathname.includes('/external/')) {
      const parts = pathname.split('/external/');
      if (parts[1]) return decodeURIComponent(parts[1].split('?')[0]);
    }
    return '';
  });
  const [count, setCount] = useState(0);
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [suggestionGigs, setSuggestionGigs] = useState([]);
  const [suggestionSlisiting, setSuggestionSlisting] = useState([]);
  const [isVisibleCloseIcon, setIsVisibleCloseIcon] = useState(false);
  const [showClear, setShowClear] = useState(true);
  const [recentClicked, setRecentClicked] = useState(false);
  const skipRef = useRef(false);
  const [dimensions, setDimensions] = useState(window.innerWidth);

  const [clearr, setClearr] = useState(false);
  const [isOpened, setisOpened] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [jobInfo, setJobInfo] = useState([1, 2]);
  const searchFlag = useSelector((state) => state.candidateReducer.searchFlag);
  const openSearchDropdownFlag = useSelector((state) => state.candidateReducer.openSearchDropdown);
  const [searchType, setSearchType] = useState("Skill Listings");
  const [closeSearchTypeModal, setCloseSearchTypeModal] = useState(false);
  const [perPage, setPerPage] = useState("24");

  let data = ["a", "b", "c", "d"];

  // const signUpLogin = useSelector((state) => state.authReducer.signUpLogin);
  // const Count = useSelector(
  //   (state) => state.searchSkillListingReducer.skillListingCount
  // );
  //const [ userProfile, setUserProfile ] = useState(localStorage.getItem('userProfile'));

  // const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const token = useSelector((state) => state.authReducer.user.authToken);

  // const searchSkillResponse = useSelector(
  //   (state) => state.searchSkillListingReducer.isSuccess
  // );



  useEffect(() => {
    if (searchFlag) {
      setSearch('');
      dispatch(toggleSearchFalse());
    }
  }, [searchFlag]);


  useEffect(() => {
    const searchTypeValue = window?.location?.href?.
    split("searchType=")[1]?.
    split("&")[0];

    if (searchTypeValue == "Skills") {
      setSearchType("Skill Listings");
    } else if (searchTypeValue == "UserName") {
      setSearchType("Candidate Name");
    } else if (searchTypeValue == "Email") {
      setSearchType("Email");
    } else if (searchTypeValue == "workHistory") {
      setSearchType("Work history");
    } else {
      setSearchType("Skill Listings");
    }
  }, [url.search, window.location.href]);

  const queryParam = useRef(history.location.pathname.includes("/query"));
  function encodeURIComponentSafe(s) {
    if (!s) {
      return s;
    }
    return encodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25"));
  }

  useEffect(() => {
    if (token && search?.length == 0) {
      dispatch(fetchRecentSearches());
      // dispatch(fetchTrendingJobs());
    }
  }, [search]);

  useEffect(() => {
    if (token) {
      dispatch(fetchTrendingJobs());
    }
  }, [token]);

  const recentSearch = useSelector(
  (state) => state.getSearchSuggestionReducer.recentsearch);


  const trendingJobs = useSelector(
  (state) => state.getSearchSuggestionReducer.trendingJobs);


  useEffect(() => {
    const recentSearchData =
    recentSearch && recentSearch?.Profiles?.RecentJobSearch ?
    recentSearch?.Profiles?.RecentJobSearch :
    [];

    setJobInfo(recentSearchData);
    // localStorage.setItem('recentSearch',recentSearch)
  }, [recentSearch]);

  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);

  function containsNumbers(str) {
    return /\d/.test(str);
  }
  useEffect(() => {

    if (props.suggestions?.searchSuggestions) {
      if (props?.suggestions?.searchSuggestions?.gigs) {
        setSuggestionGigs(props?.suggestions?.searchSuggestions?.gigs);
      }
      if (props.suggestions?.searchSuggestions?.skillsListing) {
        let skilllistings = props.suggestions?.searchSuggestions?.skillsListing;
        setSuggestionSlisting(
        Array.from(new Set(skilllistings.map((obj) => obj._id))).map(
        (name) => {
          if (containsNumbers(name)) {
            return null;
          }
          return skilllistings.find((obj) => obj._id === name);
        }));


      } else if (props.suggestions?.searchSuggestions?.talent) {
        let talentnames = props.suggestions?.searchSuggestions?.talent;
        setSuggestionSlisting(
        Array.from(new Set(talentnames.map((obj) => obj.name))).map(
        (name) => {
          return talentnames.find((obj) => obj.name === name);
        }));


      }
      // else if(props.suggestions?.searchSuggestions?.email){
      //   setSuggestionSlisting(props.suggestions?.searchSuggestions?.email);
      // }
    }
    // setSuggestionSlisting(props.suggestions?.searchSuggestions?.skillsListing);
  }, [props.suggestions]);

  useEffect(() => {
    if (props.value && showClear) {
      setSearch(props.value.trim());
      setIsVisibleCloseIcon(true);
    }
  }, [props.value, recentClicked]);

  useEffect(() => {
    if (url?.pathname?.includes("/external/")) {
      const parts = url.pathname.split("/external/");
      if (parts[1]) {
        const term = decodeURIComponent(parts[1].split("?")[0]);
        if (term) {
          setSearch(term);
          setIsVisibleCloseIcon(true);
        }
      }
    } else if (!url?.pathname?.includes("/query") && !window.location.pathname.includes("/external/")) {
      setSearch("");
      setIsVisibleCloseIcon(false);
      setisOpened(false);
      setIsSuggestion(false);
    } else {
      const parts = url.pathname.split("/query/");
      if (parts[1]) {
        const term = decodeURIComponent(parts[1].split("?")[0]);
        if (term && term !== search) {
          setSearch(term);
          setIsVisibleCloseIcon(true);
        }
      }
    }
  }, [url.pathname]);

  // useEffect(() => {
  //   queryParam.current = history.location.pathname.includes("/query");
  // }, [history.location.pathname]);

  useEffect(() => {
    const isQueryPage = history.location.pathname.includes("/query");

    if (openSearchDropdownFlag) {
      skipRef.current = true;
      setisOpened(true);
      dispatch(resetOpenSearchDropdown());
      return;
    }

    if (!isQueryPage && !skipRef.current && !history.location.pathname.includes("/external/")) {
      setSearch("");
      setisOpened(false);
      setIsVisibleCloseIcon(false);
    }

    skipRef.current = false;
  }, [queryParam, openSearchDropdownFlag]);


  const addQuery = (key, value) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    history.push({
      search: searchParams.toString()
    });
  };
  const isAiActive = useSelector((state) => state.nlSearchExternalReducer.isActive);

  const onAiToggle = (checked) => {
    if (!checked) {
      dispatch(nlSearchExternalClear());
      return;
    }

    const trimmed = search?.trim();

    if (!trimmed) return;

    dispatch(
      searchSkillListingQueryInit({
        search: trimmed,
        aiSearch: true,
        page: 1,
      })
    );

    const { filters, hasAppliedFilters } = parseQueryResultState(window.location.search);
    let filterPayload = hasAppliedFilters ? buildExternalFiltersPayload(filters, 1) : {};

    if (!hasAppliedFilters) {
      try {
        const saved = localStorage.getItem("aiTalentFilters");
        if (saved) {
          const tf = JSON.parse(saved);
          if (tf) filterPayload = tf;
        }
      } catch (_) {}
    }

    dispatch(
      nlSearchExternalInit({
        query: trimmed,
        page: 1,
        ...filterPayload,
      })
    );
  }

  const onSearch = (e) => {
    localStorage.removeItem("SelectedSkillsSearch");

    setIsSuggestion(false);
    if (search?.trim().length > 0) {
      const encodeURl = encodeURIComponentSafe(search);
      history.push({
        pathname: `/query/${encodeURl}`
      });
      setisOpened(false);
      setIsSuggestion(false);

      searchType == "Skill Listings" ?
      addQuery("searchType", "Skills") :
      searchType == "Candidate Name" ?
      addQuery("searchType", "UserName") :
      searchType == "Email" ?
      addQuery("searchType", "Email") :
      searchType == "Work history" ?
      addQuery("searchType", "workHistory") :
      setSearchType(url.search?.split("searchType=")[1]?.split("&")[0]);
      ///////////////////////
      props.searchValue(search);
      props.SearchType(searchType);
      dispatch(SearchIconClicked(true));
      props.SearchIconClicked(true);
      localStorage.setItem("search", search);
      if (isAiActive) {
        dispatch(searchSkillListingQueryInit({ search: search.trim(), aiSearch: true, page: 1 }));
      } else {
      const obj = {
        _page: 1,
        _perPage: perPage,
        search: search.replaceAll('"', ""),
        _sort: "MOST_RELEVANT",
        NearBy: null,
        Latitude: null,
        Longitude: null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: null,
        RegionId: null,
        Location: null,
        Experience: null,
        searchType:
        searchType == "Skill Listings" ?
        "Skills" :
        searchType == "Candidate Name" ?
        "UserName" :
        searchType == "Email" ?
        "Email" :
        searchType == "Work history" ?
        "workHistory" :
        "Skills"
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
      }
    }
    setJobInfo((prev) => {
      if (!jobInfo.includes(search)) {
        return [search, ...prev];
      } else {
        return [...prev];
      }
    });
  };

  const onClearRecentlySearched = (e) => {
    setJobInfo([]);
    setClearr(true);
    // localStorage.setItem("search" , " ")
    // setIsVisibleCloseIcon(false);

    e.stopPropagation();
    dispatch(clearRecentSearchInit());
    // dispatch(updateProfile({ profile: { RecentJobSearch: null } }));
  };

  const onClickSkill = (e) => {
    // dispatch(fetchKeywordsInit(e));
    setIsSuggestion(false);
    setSearch(e);
    props.searchSuggestions(e);
    const encodeURl = encodeURIComponentSafe(e);

    if (search?.length > 0) {
      const encodeURl = encodeURIComponentSafe(e);
      history.push({
        pathname: `/query/${encodeURl}`
      });
      searchType == "Skill Listings" ?
      addQuery("searchType", "Skills") :
      searchType == "Candidate Name" ?
      addQuery("searchType", "UserName") :
      searchType == "Email" ?
      addQuery("searchType", "Email") :
      searchType == "Work history" ?
      addQuery("searchType", "workHistory") :
      setSearchType(url.search?.split("searchType=")[1]?.split("&")[0]);
      props.searchValue(e);
      props.SearchType(searchType);
      localStorage.setItem("search", e);

      const obj = {
        _page: 1,
        _perPage: perPage,
        search: e,
        _sort: "MOST_RELEVANT",

        NearBy: null,
        Latitude: null,
        Longitude: null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: null,
        RegionId: null,
        Location: null,
        Experience: null,
        searchType:
        searchType == "Skill Listings" ?
        "Skills" :
        searchType == "Candidate Name" ?
        "UserName" :
        searchType == "Email" ?
        "Email" :
        "Skills"
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }
    setJobInfo((prev) => {
      if (!jobInfo.includes(e)) {
        return [e, ...prev];
      } else {
        return [...prev];
      }
    });
  };

  const onChangeSearch = (e) => {
    setIsVisibleCloseIcon(true);
    setSearch(e.target.value.trim());
    e.preventDefault();

    const obj = {
      search: e.target.value,
      type:
      searchType == "Skill Listings" ?
      "skilllisting" :
      searchType == "Candidate Name" ?
      "candidateName" :
      searchType == "Email" ?
      "email" :
      "skilllisting"
    };
    const params = { obj };
    debouceSuggestionRequest(params);

    if (e.target.value?.length > 0) {
      setIsSuggestion(true);
    }
    if (e.target.value?.length == 0) {
      setIsSuggestion(false);
      setIsVisibleCloseIcon(false);
      dispatch(ClearSearchSuggestions());
    }
  };

  const debouncedOnSearchSuggestion = debounce((val) => {
    props.searchSuggestions(val);
  }, 500);

  const debouceSuggestionRequest = useCallback((val) => debouncedOnSearchSuggestion(val), []);

  const onEnterKey = (e) => {
    if (isAiActive) {
      if (search?.trim()) {
        dispatch(searchSkillListingQueryInit({ search: search.trim(), aiSearch: true, page: 1 }));
      }
    } else {
    const obj = {
      _page: 1,
      _perPage: perPage,
      search: search,
      _sort: "MOST_RELEVANT",

      NearBy: null,
      Latitude: null,
      Longitude: null,
      maxDistance: "50",
      hide: null,
      BudgetMax: null,
      BudgetMin: null,
      BudgetType: null,
      GigType: null,
      CityId: null,
      RegionId: null,
      Location: null,
      Experience: null,
      searchType:
      searchType == "Skill Listings" ?
      "Skills" :
      searchType == "Candidate Name" ?
      "UserName" :
      searchType == "Email" ?
      "Email" :
      "Skills"
    };
    const params = { obj };
    dispatch(skillListingCount(params));
    dispatch(skillListingTotalCount(params));
    } 
    // dispatch(fetchKeywordsInit(search));

    if (e.key === "Enter" && search?.length > 0 && token) {
      const encodeURl = encodeURIComponentSafe(search);
      history.push({
        pathname: `/query/${encodeURl}`
      });
      setisOpened(false);
      setIsSuggestion(false);
      props.searchValue(search);
      props.SearchType(searchType);
      localStorage.removeItem("SelectedSkillsSearch");
      localStorage.setItem("search", search);

      setJobInfo((prev) => {
        if (!jobInfo.includes(e.target.value)) {
          return [e.target.value, ...prev];
        } else {
          return [...prev];
        }
      });
      //  onSearch(search)
      if (dimensions < 768) {
        setloggedInSearchBar(false);
        setisOpened(false);
      }
    }

    //   const obj={
    //     "_page": 1,
    //     "_perPage": perPage,
    //     "search": search
    //         }
    //   const params = {obj};
    //  dispatch(skillListingCount(params ))
  };

  useEffect(() => {
    if (dimensions < 769) {
      setPerPage("20");
    }
  }, [dimensions]);

  const onClickskilled = (data, e, Title = null) => {
    const title = Title ? Title : null;
    // setSearch(title ? title : e.target?.textContent);
    setIsVisibleCloseIcon(true);
    setSearch(
    title ?
    title :
    data.data);


    const encodeURl = encodeURIComponentSafe(
    e ?
    e :
    title ?
    title :
    data?.data);


    // dispatch(fetchKeywordsInit(e.target?.textContent));
    // if (search?.length > 0) {

    // history.push({pathname:`/query/${encodeURl}`});
    const searchTerm = e ? e : data?.data;
    if (isAiActive) {
      dispatch(searchSkillListingQueryInit({ search: searchTerm, aiSearch: true, page: 1 }));
    } else {
      const obj = {
        _page: 1,
        _perPage: perPage,
        search: searchTerm,
        _sort: "MOST_RELEVANT",

        NearBy: null,
        Latitude: null,
        Longitude: null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: null,
        RegionId: null,
        Location: null,
        Experience: null,
        searchType:
          searchType == "Skill Listings"
            ? "Skills"
            : searchType == "Candidate Name"
            ? "UserName"
            : searchType == "Email"
            ? "Email"
            : "Skills",
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }
    // }
    history.push({
      pathname: `/query/${encodeURl}`
    });
    searchType == "Skill Listings" ?
    addQuery("searchType", "Skills") :
    searchType == "Candidate Name" ?
    addQuery("searchType", "UserName") :
    searchType == "Email" ?
    addQuery("searchType", "Email") :
    searchType == "Work history" ?
    addQuery("searchType", "workHistory") :
    setSearchType(url.search?.split("searchType=")[1]?.split("&")[0]);

    props.searchValue(
    title ?
    title :
    data.data);

    props.SearchType(searchType);
    localStorage.setItem(
    "search",
    title ?
    title :
    data.data);


    props.searchSuggestions(e ?
    e :
    data.data);

    if (
    data?.e?.target?.textContent?.length > 0 ||
    data?.data?.length > 0 ||
    e.length > 0)
    {
      // setisOpened(false)
      setIsSuggestion(true);
    }
    if (
    data?.e?.target?.textContent?.length == 0 &&
    data?.data?.length == 0 &&
    e.length == 0)
    {
      setIsSuggestion(false);
      setIsVisibleCloseIcon(false);
    }
    const obj1 = {
      search: data?.data,
      type:
      searchType == "Skill Listings" ?
      "skilllisting" :
      searchType == "Candidate Name" ?
      "candidateName" :
      searchType == "Email" ?
      "email" :
      "skilllisting"
    };
    const params1 = { obj1 };
    dispatch(SearchSuggestions(params1));
    // dispatch(SearchSuggestions(e.target?.textContent));

    setJobInfo((prev) => {
      if (
      !jobInfo.includes(
      title ?
      title :
      data.data))

      {
        return [
        title ?
        title :
        data.data,
        ...prev];

      } else {
        return [...prev];
      }
    });
  };

  const onClickTrending = (data, e, Title = null) => {
    const title = Title ? Title : null;
    // setSearch(title ? title : e.target?.textContent);
    setIsVisibleCloseIcon(true);
    // dispatch(fetchKeywordsInit(e.target?.textContent));

    const encodeURl = encodeURIComponent(
      data?.item?.Title
        ? data?.item?.Title
        : title
        ? title
        : data?.e?.target?.textContent
    );
    const trendingTerm = data?.e?.target?.textContent
      ? data?.e?.target?.textContent
      : data?.item?.Title;
    if (isAiActive) {
      dispatch(searchSkillListingQueryInit({ search: trendingTerm, aiSearch: true, page: 1 }));
    } else {
      const obj = {
        _page: 1,
        _perPage: perPage,
        search: trendingTerm,
        _sort: "MOST_RELEVANT",

        NearBy: null,
        Latitude: null,
        Longitude: null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: null,
        RegionId: null,
        Location: null,
        Experience: null,
        searchType:
          searchType == "Skill Listings"
            ? "Skills"
            : searchType == "Candidate name"
            ? "UserName"
            : searchType == "Email"
            ? "Email"
            : "Skills",
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }

    history.push({
      pathname: `/query/${encodeURl}`
    });
    searchType == "Skill Listings" ?
    addQuery("searchType", "Skills") :
    searchType == "Candidate Name" ?
    addQuery("searchType", "UserName") :
    searchType == "Email" ?
    addQuery("searchType", "Email") :
    searchType == "Work history" ?
    addQuery("searchType", "workHistory") :
    setSearchType(url.search?.split("searchType=")[1]?.split("&")[0]);
    props.searchValue(
    title ?
    title :
    data?.e?.target?.textContent ?
    data?.e?.target?.textContent :
    data?.item?.Title);

    props.SearchType(searchType);
    localStorage.setItem(
    "search",
    title ?
    title :
    data?.e?.target?.textContent ?
    data?.e?.target?.textContent :
    data?.item?.Title);


    props.searchSuggestions(
    data?.e?.target?.textContent ?
    data?.e?.target?.textContent :
    data?.item?.Title);

    if (
    data?.e?.target?.textContent?.length > 0 ||
    data?.item?.Title.length > 0)
    {
      // setisOpened(false)
      setIsSuggestion(true);
    }
    if (
    data?.e?.target?.textContent?.length == 0 &&
    data?.item?.Title.length == 0)
    {
      setIsSuggestion(false);
      setIsVisibleCloseIcon(false);
    }
    const obj1 = {
      search: data?.e?.target?.textContent,
      type:
      searchType == "Skill Listings" ?
      "skilllisting" :
      searchType == "Candidate name" ?
      "candidateName" :
      searchType == "Email" ?
      "email" :
      "skilllisting"
    };
    const params1 = { obj1 };
    dispatch(SearchSuggestions(params1));
    // dispatch(SearchSuggestions(e.target?.textContent));

    setJobInfo((prev) => {
      if (
      !jobInfo.includes(
      title ?
      title :
      data?.e?.target?.textContent ?
      data?.e?.target?.textContent :
      data?.item?.Title))

      {

        return [
        title ?
        title :
        data?.e?.target?.textContent ?
        data?.e?.target?.textContent :
        data?.item?.Title,
        ...prev];

      } else {
        return [...prev];
      }
    });
  };
  function handlingSpecialCharcter(text) {
    return text?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

  const getHighlightedTextValue = (textValue) => {
    const highlight = search;
    // Split on highlight term and include term into parts, ignore case (using regular expression)
    // const parts = textValue?.split(new RegExp(`(${highlight?.replace('+','%2')})`, "gi"));
    const parts = textValue?.split(
    new RegExp(`(${handlingSpecialCharcter(highlight)})`, "gi"));

    return (
      <span>
        {parts?.map((part, i) =>
        <span
        key={i}
        className={
        part?.toLowerCase() === highlight?.toLowerCase() ?
        "Highlight_Seacrh_Value" :
        ""}>

          
            {part?.replace("%2", "+")}
          </span>)}
        
      </span>);

  };
  // useEffect(()=>{
  // },[search])
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setisOpened(false);
        }
      };
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const renderTitle1 = (title) =>
  <span className="sbar-render-title1">
      <img
    src={Suitcase}
    className="sbar-suggestion-icon"
    // style={{ margin: "0 10px 0 0", width: "18px", height: "18px" }}
    />
      {title}
    </span>;

  const renderTitle2 = (title) =>
  <span className="sbar-render-title2" key={Math.random()}>
      <img
    src={ServiceOutkine}
    className="sbar-suggestion-icon"
    // style={{ margin: "0 10px 0 0", width: "18px", height: "18px" }}
    />
      {title}
    </span>;


  // let mapping = suggestion?.map((item) => renderItem(item));

  const renderItem1 = (title) => ({
    value: title,
    label:
    <div
    // style={{
    //   display: "flex",
    //   width: "40px",
    //   fontSize: "16px",
    //   color: "#1e1e1e",

    //   // justifyContent: "space-between",
    // }}
    onClick={() => {
      window.location.replace(`/talent/search/${title}`);
    }}
    className="sbar-render-title">
      
        <div className="inner-div">{getHighlightedTextValue(title)}</div>
      </div>

  });

  const renderItem2 = (title, index) => ({
    value: title,
    label:
    <div
    className="sbar-render-title"
    onClick={() => onClickSkill(title)}
    // key={Math.random()}
    // onClick={onSearch}
    >
        <div className="inner-div">{getHighlightedTextValue(title)}</div>
      </div>

  });

  const options =
  props.token == null ?
  [
  {
    label: renderTitle1("Jobs"),
    options:
    suggestionGigs && suggestionGigs?.length > 0 ?
    suggestionGigs?.map((item) => {
      return renderItem1(item?._id);
    }) :
    []
  },
  {
    label: renderTitle2(searchType),
    options:
    suggestionSlisiting && suggestionSlisiting?.length > 1 ?
    suggestionSlisiting?.filter((item) => item?._id).map((item) => {
      return renderItem2(item?._id);
    }) :
    []
  }] :

  [
  {
    label: renderTitle2(searchType),
    options:
    suggestionSlisiting && suggestionSlisiting?.length > 1 ?
    suggestionSlisiting?.map((item, index) => {
      return renderItem2(
      searchType == "Candidate Name" ?
      item?.name :
      searchType == "Email" ?
      item.EmailAddress :
      item?._id,
      index);

    }) :
    []
  }];

  const dropdownRef = useRef();

  //Search Types ---
  const searchFiltersType = [
  "Skill listings",
  "Candidate name",
  "Email",
  "Work history"];

  // ----

  const searchMenu =
  <Menu
  className="search-menu"
  style={{
    width: dimensions < 768 ? "7.3rem" : "119px",
    position: "fixed"
  }}>
    
      <div
    onClick={(e) => {
      setSearchType(e.target.innerText);
      setCloseSearchTypeModal(false);
      dispatch(ClearSearchSuggestions());
      setSuggestionSlisting([]);
    }}
    style={{
      height: "1.7rem",
      paddingLeft: "0.5rem",
      paddingTop: "0.3rem"
    }}
    className="searchType-option">
      
        <div
      style={{
        color: searchType == "Skill Listings" ? "#118936" : "#1e1e1e",
        fontSize: "11px",
        cursor: "pointer"
      }}>
        
          Skill Listings
        </div>
      </div>

      <div
    onClick={(e) => {
      if (searchType != "Candidate Name") setSuggestionSlisting([]);
      setSuggestionGigs([]);
      setSearchType(e.target.innerText);
      setCloseSearchTypeModal(false);
      dispatch(ClearSearchSuggestions());
      setSuggestionSlisting([]);
      setSuggestionGigs([]);
    }}
    style={{
      height: "1.7rem",
      paddingLeft: "0.5rem",
      paddingTop: "0.3rem"
    }}
    className="searchType-option">
      
        <div
      style={{
        color: searchType == "Candidate Name" ? "#118936" : "#1e1e1e",
        fontSize: "11px",
        cursor: "pointer"
      }}>
        
          Candidate Name
        </div>
      </div>

      <div
    onClick={(e) => {
      if (searchType != "Email") setSuggestionSlisting([]);
      setSuggestionGigs([]);
      setSearchType(e.target.innerText);
      setCloseSearchTypeModal(false);
      dispatch(ClearSearchSuggestions());
      setSuggestionSlisting([]);
    }}
    style={{
      height: "1.7rem",
      paddingLeft: "0.5rem",
      paddingTop: "0.3rem"
    }}
    className="searchType-option">
      
        <div
      style={{
        color: searchType == "Email" ? "#118936" : "#1e1e1e",
        fontSize: "11px",
        cursor: "pointer"
      }}>
        
          Email
        </div>
      </div>

      <div
    onClick={(e) => {
      if (searchType != "Work history") setSuggestionSlisting([]);
      setSuggestionGigs([]);
      setSearchType(e.target.innerText);
      setCloseSearchTypeModal(false);
      dispatch(ClearSearchSuggestions());
      setSuggestionSlisting([]);
    }}
    style={{
      height: "1.7rem",
      paddingLeft: "0.5rem",
      paddingTop: "0.3rem"
    }}
    className="searchType-option">
      
        <div
      style={{
        color: searchType == "Work history" ? "#118936" : "#1e1e1e",
        fontSize: "11px",
        cursor: "pointer"
      }}>
        
          Work history
        </div>
      </div>
    </Menu>;


  return (
    <div
    className="searchGigs">
      
      {/* {token && (
          <div>
            <div style={{ color: "#1e1e1e", fontSize: "11px", height: "2.3rem" }}>
              Skill Listings
            </div>
            <Dropdown
              onOpenChange={() => {
                setCloseSearchTypeModal(!closeSearchTypeModal);
              }}
              trigger="click"
              style={{ height: "2.3rem" }} //loggedInSearchBar? '3.125rem':
              overlayClassName="searchdropdown"
              overlay={searchMenu}
              visible={closeSearchTypeModal}
            >
              {searchType ? 
                searchType 
                : 
                "Skill Listings"
                }
              <DownOutlined fontSize="9px !important" />
            </Button>
          </Dropdown>
          </div>
         )}
          {
          dimensions < 768 ?
          <>
          <AutoComplete
          popupClassName="certain-category-search-dropdown "
          onPressEnter={(e) => onEnterKey(e)}
          dropdownMatchSelectWidth={100}
          options={
            !(token && dimensions < 768)
              ? isSuggestion &&
                suggestionSlisiting &&
                suggestionSlisiting?.length > 1 &&
                search?.length !== 0
                ? options
                : null
              : null
          }
         >
          <div className="searchGigs">
            <Input
              style={{
                backgroundColor: "white",
                borderBottomLeftRadius: "0px",
                borderTopLeftRadius: "0px",
                color: token ? null : "black",
                // border: !token && isOpened && 'solid 2px rgb(238 235 235)',
                boxShadow:
                  !token && isOpened && "0 0 0.13rem 0 rgba(0, 0, 0, 0.25)",
              }}
              type="text"
              placeholder={
                props?.token != null
                  ? "Search" //"Find skill listings"
                  : "Find jobs or skill listings"
              }
              // placeholder={
              //   props?.token != null ?
              //     window.location.pathname=='/employer/employerdashboard'?'Find candidates' :dimensions > 768 ? "Find skill listings" //"Find skill listings"
              //     :'Find candidates or skill listings': "Find jobs or skill listings"
              // }
              value={search}
              open={true}
              onChange={(e) => {
                onChangeSearch(e);
                setSearch(e.target.value);
              }}
              // onSubmit = {(e)=> onSearch(e)}
              // onClick={bothview}
              // onPressEnter={(e) => onEnterKey(e)}
              onPressEnter={(e) => onSearch(e)}
              onClick={() => {
                //   const obj={
                //     "_page": 1,
                //     "_perPage": perPage,
                //     "search": search
                //         }
                //   const params = {obj};
                //  dispatch(skillListingCount(params ))
                if(dimensions<768){
                  setOpenDrawer(true);
                }
                // setisOpened(true);
                if (token && dimensions < 768) {
                  setloggedInSearchBar(false);
                }
              }}
              className="icons"
              onFocus={() => {
                setClearr(false);
                if (token && dimensions < 768) {
                  // setloggedInSearchBar(true);
                  // setisOpened(true);
                  setShowClear(true);
                }
              }}
            />
              {token && dimensions < 768 && (
              <>
                <img
                  src={evaArrowBackOutline}
                  className={`evaArrowBackOutline `}
                  alt=""
                  onClick={() => {
                    setloggedInSearchBar(false);
                    dispatch(ClearSearchSuggestions());
                    // setSuggestionSlisting([]);
                    // setSuggestionGigs([]);
                  }}
                />
              </>
            )}
         
            {search && (
              <img
                src={token && dimensions < 768 ? carbonCloseFilled : closeIcon}
                className={`closeIcon ${
                  isVisibleCloseIcon ? "visibleCloseIcon" : ""
                }`}
                alt=""
                onClick={(e) => {
                  setSearch("");
                  setIsVisibleCloseIcon(false);
                  if(dimensions> 768){
                    setisOpened(true);
                  }
                  token && dimensions < 768 && setloggedInSearchBar(false);
                }}
                onClick={() => setCloseSearchTypeModal(!closeSearchTypeModal)}
              >
                {searchType ? searchType : "Skill Listings"}
                <DownOutlined fontSize="9px !important" />
              </Button>
            </Dropdown>
          </div>
         )} */}


      

      {dimensions < 768 ?
      <>
          <AutoComplete
        popupClassName="certain-category-search-dropdown "
        onPressEnter={(e) => onEnterKey(e)}
        dropdownMatchSelectWidth={100}
        options={
        !(token && dimensions < 768) ?
        isSuggestion &&
        suggestionSlisiting &&
        suggestionSlisiting?.length > 1 &&
        search?.length !== 0 ?
        options :
        null :
        null}>

          
            <div className="searchGigs">
              <Input
            style={{
              backgroundColor: "white",
              borderBottomLeftRadius: "4px",
              borderTopLeftRadius: "4px",
              color: token ? null : "black",
              boxShadow:
              !token && isOpened && "0 0 0.13rem 0 rgba(0, 0, 0, 0.25)"
            }}
            type="text"
            placeholder={
            props?.token != null ?
            "Search" //"Find skill listings"
            : "Search jobs or skill listings"}

            value={search}
            open={true}
            onChange={(e) => {
              onChangeSearch(e);
            }}
            onPressEnter={(e) => {
              onSearch(e);
              setloggedInSearchBar(false);
              setisOpened(false);
              setOpenDrawer(false);
              e.stopPropagation();
              e.target.blur();
            }}
            onClick={() => {
              if (token && dimensions < 768) {
                setloggedInSearchBar(false);
                setOpenDrawer(true);
              }
            }}
            className="search-bar-box"
            onFocus={() => {
              setClearr(false);
              if (token && dimensions < 768) {
                setShowClear(true);
              }
            }} />
            

              {token && dimensions < 768 &&
            <>
                  <img
              src={evaArrowBackOutline}
              className={`evaArrowBackOutline `}
              alt=""
              onClick={() => {
                setloggedInSearchBar(false);
                dispatch(ClearSearchSuggestions());
                // setSuggestionSlisting([]);
                // setSuggestionGigs([]);
              }} />
              
                </>}
            

              {search &&
            <img
            src={
            token && dimensions < 768 ? carbonCloseFilled : closeIcon}

            className={`closeIcon ${
            isVisibleCloseIcon ? "visibleCloseIcon" : ""
            }`}
            alt=""
            onClick={(e) => {
              setSearch("");
              setIsVisibleCloseIcon(false);
              if (dimensions > 768) {
                setisOpened(true);
              }
              token && dimensions < 768 && setloggedInSearchBar(false);
            }} />}

            
              <button
            onClick={(e) => onSearch(e)}
            style={{
              width: "3rem",
              height:
              loggedInSearchBar && dimensions < 786 ?
              "3.125rem" :
              "2.3rem"
            }}>
              
                <SearchOutlined style={{ fontSize: "18px" }} />
              </button>
            </div>
          </AutoComplete>
          {openDrawer && dimensions < 768 ?
        <Drawer
        className="Search-drawer"
        open={openDrawer}
        // maskClosable={false}
        // mask={false}
        placement="top">
          
              (
              <div ref={wrapperRef} className="search-drawer-menuu">
                {dimensions < 768 &&
            <div
            className="mobileLoggedInSuggetion"
            style={{ padding: "1% 4%" }}>
              
                    <AutoComplete
              popupClassName="certain-category-search-dropdown "
              onPressEnter={(e) => onEnterKey(e)}
              dropdownMatchSelectWidth={100}
              options={
              !(token && dimensions < 768) ?
              isSuggestion &&
              suggestionSlisiting &&
              suggestionSlisiting?.length > 1 &&
              search?.length !== 0 ?
              options :
              null :
              null}>

                
                      <div className="searchGigs">
                        {token && dimensions < 768 &&
                  <>
                            <img
                    src={evaArrowBackOutline}
                    className={`evaArrowBackOutline `}
                    alt=""
                    onClick={() => {
                      setloggedInSearchBar(false);
                      setisOpened(false);
                      setOpenDrawer(false);
                      dispatch(ClearSearchSuggestions());
                      // setSuggestionSlisting([]);
                      // setSuggestionGigs([]);
                    }} />
                    
                          </>}
                  
                        <Input
                  // style={{
                  //   backgroundColor: "white",
                  //   borderBottomLeftRadius: "0px",
                  //   borderTopLeftRadius: "0px",
                  //   color: token ? null : "black",
                  //   // border: !token && isOpened && 'solid 2px rgb(238 235 235)',
                  //   boxShadow:
                  //     !token && isOpened && "0 0 0.13rem 0 rgba(0, 0, 0, 0.25)",
                  // }}
                  type="text"
                  placeholder={
                  props?.token != null ?
                  "Search" //"Find skill listings"
                  : "Search jobs or skill listings"}

                  // placeholder={
                  //   props?.token != null ?
                  //     window.location.pathname=='/employer/employerdashboard'?'Find candidates' :dimensions > 768 ? "Find skill listings" //"Find skill listings"
                  //     :'Find candidates or skill listings': "Find jobs or skill listings"
                  // }
                  value={search}
                  bordered={false}
                  open={true}
                  onChange={(e) => {
                    onChangeSearch(e);
                    setSearch(e.target.value);
                  }}
                  // allowClear
                  // onSubmit = {(e)=> onSearch(e)}
                  // onClick={bothview}
                  // onPressEnter={(e) => onEnterKey(e)}
                  onPressEnter={(e) => {
                    onSearch(e);
                    setloggedInSearchBar(false);
                    setisOpened(false);
                    setOpenDrawer(false);
                    e.stopPropagation();
                    e.target.blur();
                  }}
                  onClick={() => {
                    //   const obj={
                    //     "_page": 1,
                    //     "_perPage": perPage,
                    //     "search": search
                    //         }
                    //   const params = {obj};
                    //  dispatch(skillListingCount(params ))
                    // setisOpened(true);
                    if (token && dimensions < 768) {
                      setloggedInSearchBar(false);
                    }
                  }}
                  // className="icons"
                  onFocus={() => {
                    setClearr(false);
                    if (token && dimensions < 768) {
                      // setloggedInSearchBar(true);
                      // setisOpened(true);
                      setShowClear(true);
                    }
                  }} />
                  

                        {search &&
                  <img
                  src={
                  token && dimensions < 768 ?
                  carbonCloseFilled :
                  closeIcon}

                  className={`closeIcon ${
                  isVisibleCloseIcon ? "visibleCloseIcon" : ""
                  }`}
                  alt=""
                  onClick={(e) => {
                    setSearch("");
                    setIsVisibleCloseIcon(false);
                    setisOpened(true);
                    token &&
                    dimensions < 768 &&
                    setloggedInSearchBar(false);
                  }} />}

                  
                        {/* <button
                    onClick={(e) => onSearch(e)}
                    style={{
                    width: "3rem",
                    height:
                    loggedInSearchBar && dimensions < 786 ? "3.125rem" : "2.3rem",
                    }}
                    >
                    <SearchOutlined style={{ fontSize: "18px" }} />
                    </button> */}
                      </div>
                    </AutoComplete>
                    {search && search?.length >= 0 && suggestionGigs ?
              /////////
              // suggestionSlisiting?.map((item, index) => {
              //   return (
              //     searchType == "Candidate name"
              //       ? item?.name
              //       : searchType == "Email"
              //       ? item.EmailAddress
              //       : item?._id
              //       ,
              //       index
              //   );
              // })

              // // /////////////
              suggestionSlisiting.map((item) => {
                //  const { _id , ...rest}=item
                return item;
              }).
              map((item, index) => {
                return (
                  <>
                              {item != null ?
                    <React.Fragment key={index}>
                              <div
                      style={{}}
                      className="mobileLoggedInSuggetionOption"
                      onClick={(e) => {
                        localStorage.removeItem("SelectedSkillsSearch");
                        setSearch(item?._id);
                        const obj = {
                          _page: 1,
                          _perPage: perPage,
                          search:
                          searchType == "Candidate Name" ?
                          item?.name :
                          searchType == "Email" ?
                          item.EmailAddress :
                          searchType == "Skill Listings" ?
                          item?._id :
                          "",
                          _sort: "MOST_RELEVANT",

                          NearBy: null,
                          Latitude: null,
                          Longitude: null,
                          maxDistance: "50",
                          hide: null,
                          BudgetMax: null,
                          BudgetMin: null,
                          BudgetType: null,
                          GigType: null,
                          CityId: null,
                          RegionId: null,
                          Location: null,
                          Experience: null,
                          searchType:
                          searchType == "Skill Listings" ?
                          "Skills" :
                          searchType == "Candidate Name" ?
                          "UserName" :
                          searchType == "Email" ?
                          "Email" :
                          "Skills"
                        };
                        const params = { obj };
                        dispatch(skillListingCount(params));
                        dispatch(skillListingTotalCount(params));
                        props.SearchType(searchType);
                        props.searchSuggestions(e.target.value);
                        let dataObj = {
                          e: e,
                          data:
                          searchType == "Candidate Name" ?
                          item?.name :
                          searchType == "Email" ?
                          item.EmailAddress :
                          searchType == "Skill Listings" ?
                          item?._id :
                          ""
                        };
                        onClickskilled(dataObj);
                        if (dimensions < 768) {
                          setloggedInSearchBar(false);
                          localStorage.removeItem("SelectedSkillsSearch");
                          setisOpened(false);
                          setOpenDrawer(false);
                          e.stopPropagation();
                        }
                      }}>
                        
                                <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center"
                        }}>
                          
                                  <SearchOutlined
                          style={{
                            color: "#7e7e7e",
                            marginRight: "0.5rem",
                            fontSize: "15px"
                          }} />
                          
                                  {getHighlightedTextValue(
                          searchType == "Candidate Name" ?
                          item?.name :
                          searchType == "Email" ?
                          item.EmailAddress :
                          searchType == "Skill Listings" ?
                          item?._id :
                          "")}
                          
                                </div>
                              </div>
                            </React.Fragment> : null}
                            </>);

              }) :
              ""}
                  </div>}
            
                {!clearr &&
            recentSearch?.length != 0 &&
            jobInfo?.length != 0 &&
            <>
                      <div className="dropdown-menuu-insidebox">
                        <div className="dropdown-menuu-recentSearch">
                          Recently searched
                        </div>
                        <div
                // onClick={clearRecentSearch}
                className="dropdown-menuu-clear-click"
                onClick={(e) => onClearRecentlySearched(e)}>
                  
                          Clear
                        </div>
                      </div>

                      <div className="dropdown-menuu-clear-recentjobss-inner">
                        {jobInfo &&
                jobInfo?.
                slice(
                jobInfo?.length > 3 ? jobInfo?.length - 4 : 0,
                jobInfo?.length).

                reverse().
                map((data, key) => {
                  return (
                    data &&
                    <>
                                    <div
                      key={key}
                      className="dropdown-menuu-clear-recentjobss-inside"
                      onClick={(e) => {
                        localStorage.removeItem("SelectedSkillsSearch");
                        setRecentClicked(!recentClicked);
                        // setSearch(e.target.innerText?e.target.innerText :data)
                        const obj = {
                          _page: 1,
                          _perPage: perPage,
                          search: data ? data : " ",
                          _sort: "MOST_RELEVANT",

                          NearBy: null,
                          Latitude: null,
                          Longitude: null,
                          maxDistance: "50",
                          hide: null,
                          BudgetMax: null,
                          BudgetMin: null,
                          BudgetType: null,
                          GigType: null,
                          CityId: null,
                          RegionId: null,
                          Location: null,
                          Experience: null,
                          searchType:
                          searchType == "Skill Listings" ?
                          "Skills" :
                          searchType == "Candidate Name" ?
                          "UserName" :
                          searchType == "Email" ?
                          "Email" :
                          "Skills"
                        };
                        const params = { obj };
                        localStorage.removeItem("SelectedSkillsSearch");
                        dispatch(skillListingCount(params));
                        dispatch(
                        skillListingTotalCount(params));

                        props.SearchType(searchType);
                        props.searchSuggestions(e.target.value);

                        onClickskilled({ e, data });
                        if (dimensions < 768) {
                          setloggedInSearchBar(false);
                          setisOpened(false);
                          setOpenDrawer(false);
                          e.stopPropagation();
                        }
                      }}>
                        
                                      <img
                        className="dropdown-menuu-recentlyview-icon"
                        src={RecentlyViewed}
                        alt="fluentlocation"

                        // onClick={ onClickskilled(data)}
                        />
                                      <div
                        className="dropdown-menuu-clear-recentjobss-onclick"
                        onClick={(e) => {
                          setRecentClicked(!recentClicked);
                        }}>
                          
                                        {data ? data : " "}
                                      </div>
                                    </div>
                                  </>);


                })}
                      </div>
                    </>}
            
                <div className="dropdown-menuu-clear-trendingJobss">
                  Trending skill listings
                </div>
                <div className="dropdown-menuu-clear-recentjobss-inner">
                  {isHC(userProfile?.Professions?.ProfessionCode) ?
              trendingJobs?.SkillListing?.HC?.length > 0 &&
              trendingJobs?.SkillListing?.HC?.map((item, key) => {
                return (
                  <div
                  key={key}
                  className="dropdown-menuu-clear-recentjobss-inside"
                  onClick={(e) => {
                    localStorage.removeItem("SelectedSkillsSearch");
                    const obj = {
                      _page: 1,
                      _perPage: perPage,
                      search: item ? item.Title : "",
                      _sort: "MOST_RELEVANT",

                      NearBy: null,
                      Latitude: null,
                      Longitude: null,
                      maxDistance: "50",
                      hide: null,
                      BudgetMax: null,
                      BudgetMin: null,
                      BudgetType: null,
                      GigType: null,
                      CityId: null,
                      RegionId: null,
                      Location: null,
                      Experience: null,
                      searchType:
                      searchType == "Skill Listings" ?
                      "Skills" :
                      searchType == "Candidate Name" ?
                      "UserName" :
                      searchType == "Email" ?
                      "Email" :
                      "Skills"
                    };
                    const params = { obj };
                    dispatch(skillListingCount(params));
                    dispatch(skillListingTotalCount(params));
                    props.SearchType(searchType);
                    onClickTrending({ item, e });
                    setRecentClicked(!recentClicked);
                    if (dimensions < 768) {
                      setloggedInSearchBar(false);
                      setisOpened(false);
                      setOpenDrawer(false);
                    }
                  }}>
                    
                            <img
                    src={ArrowTrending}
                    alt="trending arrow"
                    className="dropdown-menuu-recentlyview-icon" />
                    
                            <div
                    className="dropdown-menuu-clear-recentjobss-onclick"
                    onClick={(e) => {
                      setRecentClicked(!recentClicked);
                    }}>
                      
                              {item ? item.Title : ""}
                            </div>
                          </div>);

              }) :
              trendingJobs?.SkillListing?.IT?.length > 0 &&
              trendingJobs?.SkillListing?.IT?.map((item, key) => {
                return (
                  <div
                  key={key}
                  className="dropdown-menuu-clear-recentjobss-inside"
                  onClick={(e) => {
                    localStorage.removeItem("SelectedSkillsSearch");
                    const obj = {
                      _page: 1,
                      _perPage: perPage,
                      search: item ? item.Title : "",
                      _sort: "MOST_RELEVANT",

                      NearBy: null,
                      Latitude: null,
                      Longitude: null,
                      maxDistance: "50",
                      hide: null,
                      BudgetMax: null,
                      BudgetMin: null,
                      BudgetType: null,
                      GigType: null,
                      CityId: null,
                      RegionId: null,
                      Location: null,
                      Experience: null,
                      searchType:
                      searchType == "Skill Listings" ?
                      "Skills" :
                      searchType == "Candidate Name" ?
                      "UserName" :
                      searchType == "Email" ?
                      "Email" :
                      "Skills"
                    };
                    const params = { obj };
                    dispatch(skillListingCount(params));
                    dispatch(skillListingTotalCount(params));
                    props.SearchType(searchType);
                    onClickTrending({ item, e });
                    setRecentClicked(!recentClicked);
                    if (dimensions < 768) {
                      setloggedInSearchBar(false);
                      setisOpened(false);
                    }
                  }}>
                    
                            <img
                    src={ArrowTrending}
                    alt="trending arrow"
                    className="dropdown-menuu-recentlyview-icon" />
                    
                            <div
                    className="dropdown-menuu-clear-recentjobss-onclick"
                    onClick={(e) => {
                      setRecentClicked(!recentClicked);
                    }}>
                      
                              {item ? item.Title : ""}
                            </div>
                          </div>);

              })}
                </div>
                {/* <div className="dropdown-menuu-clear-recentjobss-inner">
              {trendingJobs?.SkillListing?.map((data, key) => {
              return (
              <div
              key={key}
              className="dropdown-menuu-clear-recentjobss-inside"
              onClick={(e) => {
              
              const obj={
              "_page": 1,
              "_perPage": perPage,
              "search":data ? data.JobTitle : "",
              "_sort": "MOST_RELEVANT",
                  }
              const params = {obj};
              dispatch(skillListingCount(params ))
                           
              onClickskilled(e);
              if (dimensions < 768) {
              setloggedInSearchBar(false);
              setisOpened(false);
              }
              }}
              >
                        <img
              src={ArrowTrending}
              alt="trending arrow"
              className="dropdown-menuu-recentlyview-icon"
              />
              <span className="dropdown-menuu-clear-recentjobss-onclick">
              {data ? data.Title : ""}
              </span>
              </div>
              );
              })}
              </div> */}


            
              </div>
              )
            </Drawer> :
        null}
        </> :
      null}

      {dimensions > 768 &&
      <AutoComplete
      popupClassName="certain-category-search-dropdown "
      onPressEnter={(e) => onEnterKey(e)}
      dropdownMatchSelectWidth={100}
      onSelect={(e) => onClickSkill(e)}
      options={
      !(token && dimensions < 768) ?
      isSuggestion &&
      suggestionSlisiting &&
      suggestionSlisiting?.length > 1 &&
      search?.length !== 0 ?
      options :
      null :
      null}>

        
          <div className="searchGigs">
            <Input
          style={{
            backgroundColor: "white",
            borderBottomLeftRadius: "4px",
            borderTopLeftRadius: "4px",
            color: token ? null : "black",
            // border: !token && isOpened && 'solid 2px rgb(238 235 235)',
            boxShadow:
            !token && isOpened && "0 0 0.13rem 0 rgba(0, 0, 0, 0.25)"
          }}
          type="text"
          placeholder={
          props?.token != null ?
          "Search" //"Find skill listings"
          : "Search jobs or skill listings"}

          // placeholder={
          //   props?.token != null ?
          //     window.location.pathname=='/employer/employerdashboard'?'Find candidates' :dimensions > 768 ? "Find skill listings" //"Find skill listings"
          //     :'Find candidates or skill listings': "Find jobs or skill listings"
          // }
          value={search}
          open={true}
          onChange={(e) => {
            onChangeSearch(e);
            setSearch(e.target.value);
          }}
          // onSubmit = {(e)=> onSearch(e)}
          // onClick={bothview}
          // onPressEnter={(e) => onEnterKey(e)}
          onPressEnter={(e) => onSearch(e)}
          onClick={() => {
            //   const obj={
            //     "_page": 1,
            //     "_perPage": perPage,
            //     "search": search
            //         }
            //   const params = {obj};
            //  dispatch(skillListingCount(params ))
            if (dimensions > 768) {
              setisOpened(true);
            }
            if (token && dimensions < 768) {
              setloggedInSearchBar(false);
            }
          }}
          className="icons search-bar-box"
          onFocus={() => {
            setClearr(false);
            if (token && dimensions < 768) {
              // setloggedInSearchBar(true);
              // setisOpened(true);
              setShowClear(true);
            }
          }} />
          
            {token && dimensions < 768 &&
          (<>
                <img
                  src={evaArrowBackOutline}
                  className={`evaArrowBackOutline `}
                  alt=""
                  onClick={() => {
                    setloggedInSearchBar(false);
                    dispatch(ClearSearchSuggestions());
                    // setSuggestionSlisting([]);
                    // setSuggestionGigs([]);
                  }}
                />
              </>
            )}

            {search && (
              <img
                src={token && dimensions < 768 ? carbonCloseFilled : closeIcon}
                className={`closeIcon ${
                  isVisibleCloseIcon ? "visibleCloseIcon" : ""
                }`}
                alt=""
                onClick={(e) => {
                  setSearch("");
                  setIsVisibleCloseIcon(false);
                  if (dimensions > 768) {
                    setisOpened(true);
                  }
                  token && dimensions < 768 && setloggedInSearchBar(false);
                }}
                style={{right: token ? '' : '3.5rem'}}
              />
            )}
            <button
          onClick={(e) => onSearch(e)}
          style={{
            width: "3rem",
            height:
            loggedInSearchBar && dimensions < 786 ? "3.125rem" : "2.5rem"
          }}>
            
              <SearchOutlined style={{ fontSize: "18px" }} />
            </button>
          </div>
        </AutoComplete>}
      

      {isOpened && (dimensions < 768 || search?.length === 0) && token && (dimensions < 768 || (!clearr && recentSearch?.length != 0 && jobInfo?.length != 0)) ?
      <div ref={wrapperRef} className="dropdown-menuu">
          {dimensions < 768 &&
        <div
        className="mobileLoggedInSuggetion"
        style={{ padding: "1% 4%" }}>
          
              {search && search?.length >= 0 && suggestionGigs ?
          /////////
          // suggestionSlisiting?.map((item, index) => {
          //   return (
          //     searchType == "Candidate name"
          //       ? item?.name
          //       : searchType == "Email"
          //       ? item.EmailAddress
          //       : item?._id
          //       ,
          //       index
          //   );
          // })

          // // /////////////
          suggestionSlisiting.map((item, index) => {
            return (
              <React.Fragment key={index}>
                        <div
                className="mobileLoggedInSuggetionOption"
                onClick={(e) => {
                  setSearch(item?._id);
                  localStorage.removeItem("SelectedSkillsSearch");
                  const obj = {
                    _page: 1,
                    _perPage: perPage,
                    search:
                    searchType == "Candidate Name" ?
                    item?.name :
                    searchType == "Email" ?
                    item.EmailAddress :
                    item?._id,
                    _sort: "MOST_RELEVANT",

                    NearBy: null,
                    Latitude: null,
                    Longitude: null,
                    maxDistance: "50",
                    hide: null,
                    BudgetMax: null,
                    BudgetMin: null,
                    BudgetType: null,
                    GigType: null,
                    CityId: null,
                    RegionId: null,
                    Location: null,
                    Experience: null,
                    searchType:
                    searchType == "Skill Listings" ?
                    "Skills" :
                    searchType == "Candidate Name" ?
                    "UserName" :
                    searchType == "Email" ?
                    "Email" :
                    "Skills"
                  };
                  const params = { obj };
                  dispatch(skillListingCount(params));
                  dispatch(skillListingTotalCount(params));
                  props.SearchType(searchType);
                  props.searchSuggestions(e.target.value);

                  const encodeURl = encodeURIComponentSafe(search);
                  history.push({
                    pathname: `/query/${encodeURl}`
                  });
                  props.searchValue(search);
                  props.SearchType(searchType);
                  localStorage.removeItem("SelectedSkillsSearch");
                  localStorage.setItem("search", search);

                  let data =
                  searchType == "Candidate Name" ?
                  item?.name :
                  searchType == "Email" ?
                  item.EmailAddress :
                  item?._id;
                  // onClickskilled({e:e,data:data});
                  let dataObj = {
                    e: e,
                    data: data
                  };
                  onClickskilled(dataObj);
                  if (dimensions < 768) {
                    setloggedInSearchBar(false);
                    setisOpened(false);
                    setOpenDrawer(false);
                    e.stopPropagation();
                  }
                }}>
                  
                          <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                  }}>
                    
                            <SearchOutlined
                    style={{
                      color: "#7e7e7e",
                      marginRight: "0.5rem",
                      fontSize: "15px"
                    }} />
                    
                            {getHighlightedTextValue(
                    searchType == "Candidate Name" ?
                    item?.name :
                    searchType == "Email" ?
                    item.EmailAddress :
                    item?._id)}
                    
                          </div>
                        </div>
                      </React.Fragment>);

          }) :
          ""}
            </div>}
        
          {!clearr && recentSearch?.length != 0 && jobInfo?.length != 0 &&
        <>
              <div className="dropdown-menuu-insidebox">
                <div className="dropdown-menuu-recentSearch">
                  Recently searched
                </div>
                <div
            // onClick={clearRecentSearch}
            className="dropdown-menuu-clear-click"
            onClick={(e) => onClearRecentlySearched(e)}>
              
                  Clear
                </div>
              </div>

              <div className="dropdown-menuu-clear-recentjobss-inner">
                {jobInfo &&
            jobInfo?.
            slice(
            jobInfo?.length > 3 ? jobInfo?.length - 4 : 0,
            jobInfo?.length).

            reverse().
            map((data, key) => {
              return (
                data &&
                <>
                            <div
                  key={key}
                  className="dropdown-menuu-clear-recentjobss-inside"
                  onClick={(e) => {
                    localStorage.removeItem("SelectedSkillsSearch");
                    setRecentClicked(!recentClicked);
                    // setSearch(e.target.innerText?e.target.innerText :data)
                    const obj = {
                      _page: 1,
                      _perPage: perPage,
                      search: data ? data : " ",
                      _sort: "MOST_RELEVANT",

                      NearBy: null,
                      Latitude: null,
                      Longitude: null,
                      maxDistance: "50",
                      hide: null,
                      BudgetMax: null,
                      BudgetMin: null,
                      BudgetType: null,
                      GigType: null,
                      CityId: null,
                      RegionId: null,
                      Location: null,
                      Experience: null,
                      EmployeeAssociation: null,
                      searchType:
                      searchType == "Skill Listings" ?
                      "Skills" :
                      searchType == "Candidate Name" ?
                      "UserName" :
                      searchType == "Email" ?
                      "Email" :
                      "Skills"
                    };
                    const params = { obj };
                    localStorage.removeItem("SelectedSkillsSearch");
                    dispatch(skillListingCount(params));
                    dispatch(skillListingTotalCount(params));
                    props.SearchType(searchType);
                    props.searchSuggestions(e.target.value);

                    onClickskilled({ e, data });
                    if (dimensions < 768) {
                      setloggedInSearchBar(false);
                      setisOpened(false);
                      e.stopPropagation();
                    }
                  }}>
                    
                              <img
                    className="dropdown-menuu-recentlyview-icon"
                    src={RecentlyViewed}
                    alt="fluentlocation"

                    // onClick={ onClickskilled(data)}
                    />
                              <div
                    className="dropdown-menuu-clear-recentjobss-onclick"
                    onClick={(e) => {
                      setRecentClicked(!recentClicked);
                    }}>
                      
                                {data ? data : " "}
                              </div>
                            </div>
                          </>);


            })}
              </div>
            </>}
        
          {false && <div className="dropdown-menuu-clear-trendingJobss">
            Trending skill listings
          </div>}
          {false && <div className="dropdown-menuu-clear-recentjobss-inner">
            {isHC(userProfile?.Professions?.ProfessionCode) ?
          trendingJobs?.SkillListing?.HC?.length > 0 &&
          trendingJobs?.SkillListing?.HC?.map((item, key) => {
            return (
              <div
              key={key}
              className="dropdown-menuu-clear-recentjobss-inside"
              onClick={(e) => {
                localStorage.removeItem("SelectedSkillsSearch");
                const obj = {
                  _page: 1,
                  _perPage: perPage,
                  search: item ? item.Title : "",
                  _sort: "MOST_RELEVANT",

                  NearBy: null,
                  Latitude: null,
                  Longitude: null,
                  maxDistance: "50",
                  hide: null,
                  BudgetMax: null,
                  BudgetMin: null,
                  BudgetType: null,
                  GigType: null,
                  CityId: null,
                  RegionId: null,
                  Location: null,
                  Experience: null,
                  searchType:
                  searchType == "Skill Listings" ?
                  "Skills" :
                  searchType == "Candidate Name" ?
                  "UserName" :
                  searchType == "Email" ?
                  "Email" :
                  "Skills"
                };
                const params = { obj };
                dispatch(skillListingCount(params));
                dispatch(skillListingTotalCount(params));
                props.SearchType(searchType);
                onClickTrending({ item, e });
                setRecentClicked(!recentClicked);
                if (dimensions < 768) {
                  setloggedInSearchBar(false);
                  setisOpened(false);
                }
              }}>
                
                      <img
                src={ArrowTrending}
                alt="trending arrow"
                className="dropdown-menuu-recentlyview-icon" />
                
                      <div
                className="dropdown-menuu-clear-recentjobss-onclick"
                onClick={(e) => {
                  setRecentClicked(!recentClicked);
                }}>
                  
                        {item ? item.Title : ""}
                      </div>
                    </div>);

          }) :
          trendingJobs?.SkillListing?.IT?.length > 0 &&
          trendingJobs?.SkillListing?.IT?.map((item, key) => {
            return (
              <div
              key={key}
              className="dropdown-menuu-clear-recentjobss-inside"
              onClick={(e) => {
                localStorage.removeItem("SelectedSkillsSearch");
                const obj = {
                  _page: 1,
                  _perPage: perPage,
                  search: item ? item.Title : "",
                  _sort: "MOST_RELEVANT",

                  NearBy: null,
                  Latitude: null,
                  Longitude: null,
                  maxDistance: "50",
                  hide: null,
                  BudgetMax: null,
                  BudgetMin: null,
                  BudgetType: null,
                  GigType: null,
                  CityId: null,
                  RegionId: null,
                  Location: null,
                  Experience: null,
                  searchType:
                  searchType == "Skill Listings" ?
                  "Skills" :
                  searchType == "Candidate Name" ?
                  "UserName" :
                  searchType == "Email" ?
                  "Email" :
                  "Skills"
                };
                const params = { obj };
                dispatch(skillListingCount(params));
                dispatch(skillListingTotalCount(params));
                props.SearchType(searchType);
                onClickTrending({ item, e });
                setRecentClicked(!recentClicked);
                if (dimensions < 768) {
                  setloggedInSearchBar(false);
                  setisOpened(false);
                }
              }}>
                
                      <img
                src={ArrowTrending}
                alt="trending arrow"
                className="dropdown-menuu-recentlyview-icon" />
                
                      <div
                className="dropdown-menuu-clear-recentjobss-onclick"
                onClick={(e) => {
                  setRecentClicked(!recentClicked);
                }}>
                  
                        {item ? item.Title : ""}
                      </div>
                    </div>);

          })}
          </div>}
          {/* <div className="dropdown-menuu-clear-recentjobss-inner">
          {trendingJobs?.SkillListing?.map((data, key) => {
          return (
            <div
              key={key}
              className="dropdown-menuu-clear-recentjobss-inside"
              onClick={(e) => {
                 
                const obj={
                  "_page": 1,
                  "_perPage": perPage,
                  "search":data ? data.JobTitle : "",
                  "_sort": "MOST_RELEVANT",
                      }
                const params = {obj};
               dispatch(skillListingCount(params ))
               
               
                onClickskilled(e);
                if (dimensions < 768) {
                  setloggedInSearchBar(false);
                  setisOpened(false);
                }
              }}
            >
                           <img
                src={ArrowTrending}
                alt="trending arrow"
                className="dropdown-menuu-recentlyview-icon"
              />
              <span className="dropdown-menuu-clear-recentjobss-onclick">
                {data ? data.Title : ""}
              </span>
                </div>
            );
          })}
          </div> */}

        
        </div> :
      null}
    </div>);

};

const mapStateToProps = (state) => {
  return {
    skillListings: state.searchSkillListingReducer.skillListings,
    value: state.searchSkillListingReducer.searchvalue,
    error: state.searchSkillListingReducer,
    token: state.authReducer.user?.authToken,
    suggestions: state.searchSkillListingReducer.searchSuggestions,
    type: state.searchSkillListingReducer.searchtype,
    searchIconClicked: state.searchSkillListingReducer.searchIconClicked
    // userProfile: state.profileReducer.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // GetGigs: (params) => {
    //   dispatch(fetchGigs(params)); // action dispatched
    // },
    // SearchValue
    SearchResponseRequested: (params) => {
      dispatch(SearchResponseRequested(params)); // action dispatched
    },
    searchResponse: (params) => {
      dispatch(SearchResponse(params)); // action dispatched
    },
    searchValue: (params) => {
      dispatch(SearchValue(params)); // action dispatched
    },

    SearchType: (params) => {
      dispatch(SearchType(params));
    },

    SearchIconClicked: (params) => {
      dispatch(SearchIconClicked(params));
    },


    searchSuggestions: (params) => {
      dispatch(fetchSearchSuggestions(params));
    },

    RecentSearches: (params) => {
      dispatch(fetchRecentSearches(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);